import { makeStyles } from '@fluentui/react-components';

export const useMenuStyles = makeStyles({
  menuItem: {
    color: '#000000',
    background: 'transparent',
    border: 0,
    padding: '6px',
  },
});